<template>
	<div v-if="data">
		<div class="row">
			<div class="col-md-10 col-md-push-2 p-r-10 p-l-0">
				<iframe
					class="embed-responsive-item"
					:src="link"
					:height="iframe.style.height"
					:width="iframe.style.width"
					@load="resizeIframe($event)" frameborder="0">
				</iframe>
			</div>
			<div class="col-md-2 col-md-pull-10 p-r-0 p-l-0">
				<template v-if="data.assigned">
					<template v-if="data.assigned.profile">
						<div class="text-center p-t-20">
							<template v-if="data.assigned.profile.avatar">
								<img :src="data.assigned.profile.avatar" width="200" class="img-circle img-responsive p-r-30 p-l-30 center-block">
							</template>
							<h3>
								<strong>{{ data.assigned.profile.first_name }} {{ data.assigned.profile.last_name }}</strong>
							</h3>
							<p>
								<span v-if="data.assigned.email">
									<a :href="'mailto:' + data.assigned.email">
										{{ data.assigned.email }}
									</a><br>
								</span>
								<span v-if="data.assigned.profile.phone">
									<a :href="'tel:' + data.assigned.profile.phone">
										{{ data.assigned.profile.phone }}
									</a>
								</span>
								<span v-if="data.assigned.profile.mobile">
									<span v-if="data.assigned.profile.phone">-</span>
									<a :href="'tel:' + data.assigned.profile.mobile">
										{{ data.assigned.profile.mobile }}
									</a>
								</span><br>
							</p>
							<p v-if="data.assigned.profile.place">
								{{ data.assigned.profile.place.name }}<br>
								{{ data.assigned.profile.place.postal_code }}
								{{ data.assigned.profile.place.locality }}<br>
								{{ data.assigned.profile.place.administrative_area_level_2 }} {{ data.assigned.profile.place.country }}
							</p>
						</div>
					</template>
				</template>
				<hr>
				<h2 class="text-center">
					<template v-if="user">
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/' + data.id">
							<strong>Presupuesto Nº{{ data.id }}</strong>
						</router-link>
					</template>
					<template v-else>
						<strong>Presupuesto Nº{{ data.id }}</strong>
					</template>
				</h2>
				<template v-if="data.budget_status_id == 5">
					<div class="text-center">
						<template v-if="data.status">
							<button :class="'btn btn-' + data.status.class + ' btn-lg btn-rounded m-b-20 no-link'">
								<template v-if="data.status.lang">
									{{ data.status.lang.name }}
								</template>
								<template>
									{{ data.status.name }}
								</template>
							</button>
						</template>
					</div>
				</template>
				<template v-else>
					<template v-if="!user">
						<div class="text-center">
							<button v-if="data.budget_status_id == 2" @click="open" class="btn btn-success btn-lg btn-rounded m-b-20">
								Aceptar
							</button>
						</div>
					</template>
				</template>
				<div class="btn-group-vertical btn-block m-t-20" role="group">
					<template v-if="data.assigned">
						<template v-if="data.assigned.profile">
							<template v-if="data.assigned.profile.mobile">
								<a :href="'tel:' + data.assigned.profile.mobile" class="btn btn-default">
									<i class="fa fa-phone" aria-hidden="true"></i> Llamar
								</a>
							</template>
						</template>
						<a :href="'mailto:' + data.assigned.email" class="btn btn-default">
							<i class="fa fa-envelope-o" aria-hidden="true"></i> Enviar correo
						</a>
						<template v-if="apiWhatsapp">
							<a :href="apiWhatsapp" target="_blank" class="btn btn-default">
								<i class="fa fa-whatsapp" aria-hidden="true"></i>
								Enviar mensaje
							</a>
						</template>
					</template>
				</div>
			</div>
		</div>

		<div class="modal fade" tabindex="-1" :id="modal.selector" role="dialog">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						<h4 class="modal-title">Aceptar presupuesto</h4>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-12">
								<div class="checkbox checkbox-success">
									<input type="checkbox" v-model="checkbox">
									<label @click="checkbox = !checkbox">
										Acepto las condiciones de pago y los términos y condiciones de este presupuesto
									</label>
								</div>
								<template v-if="!checkbox">
									<div class="alert alert-warning">
										Debe marcar la casilla para aceptar las condiciones del presupuesto.
									</div>
								</template>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button :disabled="!checkbox" ref="btnAccept" @click="acceptBudget" type="button" class="btn btn-success">Aceptar</button>
						<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				random: this.$route.params.random,
				data: null,
				link: null,
				checkbox: false,
				apiWhatsapp: null,

				modal: {
					selector: 'modal-accept-budget',
				},

				iframe: {
					style: {
						width: null,
						height: null,
					},
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			open() {
				this.checkbox = false
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getData() {
				if(this.random) {
					this.$http.get('management/budgets/' + this.random)
					.then(response => {
						this.data = response.body
						this.loadLink()
						this.loadApiWhatsapp()
					}, function(error) {
						console.log(error)
					})
				}
			},
			loadLink() {
				this.link = this.$env.ROOT + '/' + this.$lang.getLang() + '/' + this.$platform.slug +'/pdf/viewer'
				if(this.data) {
					if(this.data.link) {
						this.link = this.link + '?file=' + this.data.link
					}
				}
			},
			acceptBudget() {
				var l = Ladda.create(this.$refs.btnAccept)
				l.start()
				this.$http.get('management/budgets/' + this.data.id + '/accept')
				.then(response => {
					this.close()
					l.stop()
					this.getData()
					swal(response.body.title, response.body.text, response.body.type);
				}).catch(function(response) {
					l.stop()
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning"
					});
				})
			},
			loadApiWhatsapp() {
				//-- Implementar prefijo para los usuarios en la BBDD
				this.apiWhatsapp = null
				if(this.data) {
					if(this.data.assigned) {
						if(this.data.assigned.profile) {
							if(this.data.assigned.profile.mobile) {
								var prefix = '+34'
								var phone = this.data.assigned.profile.mobile.replace(/\s/g,'')
								var text = 'Hola.'
								this.apiWhatsapp = 'https://api.whatsapp.com/send?phone=' + prefix + phone + '&text=' + text
							}
						}
					}
				}
			},
			resizeIframe() {
				this.iframe.style = {
					width: '100%',
					height: window.innerHeight,
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/public/management/budgets/views/BudgetViewer.vue